import { ParsedCookiesType, CookieType } from './cookieTypes'

export const getCookies = (): ParsedCookiesType =>
  document.cookie
    .split(';')
    .reduce((acc: ParsedCookiesType, cookie: string) => {
      const [name, value] = cookie.trim().split('=')

      acc[name] = value

      return acc
    }, {})

export const getCookie = (name: string): string | null =>
  getCookies()[name] || null

export const setCookie = ({
  name,
  value,
  domain,
  path = '/',
  secure,
  sameSite
}: CookieType): string =>
  document.cookie = `${name}=${value};path=${path};${domain ? `domain=${domain};` : ''}${secure ? 'secure;' : ''}${sameSite ? `SameSite=${sameSite}` : ''}`

